import { Component, OnDestroy, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router} from '@angular/router';
import { CommonServiceService } from '../services/common-service.service';
import { environment } from 'src/environments/environment';

import { interval, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { GDPRComponent } from '../gdpr/gdpr.component';

function passwordMatchValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const password = control.get('password');
  const confirmPassword = control.get('confirmPassword');

  if (!password || !confirmPassword) {
    return null;
  }

  return password.value === confirmPassword.value ? null : { passwordMismatch: true };
}
@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss'],
  animations: [
    trigger('fadeSlideIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('400ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ])
  ]
})
export class SignUpComponent implements OnInit, OnDestroy {
  step: 'email' | 'form' = 'email';
  emailForm!: FormGroup;
  emailCheckLoading = false;
  emailCheckError = '';
  verifiedData: any = null;

  public singupForm !: FormGroup;
  ipNames: any = [
    {label: 'Government official', id: '1', value: 'Govt official'},
    {label: 'Researcher', id: '2', value: 'researcher'},
    {label: 'Brand representative', id: '3', value: 'brand representative'},
    {label: 'Other', id: '4', value: 'other'}
  ];
  isSignUpSuccess = false;
  constructor(public dialogRef: MatDialogRef<SignUpComponent>,
              public dialog: MatDialog,
              private formBuilder: FormBuilder,
              private snackBar: MatSnackBar,
              private router: Router,
              private commonService: CommonServiceService,
    ) {

      this.createSignUpForm();
      this.initEmailForm();
      this.initializeOtpForm();
      this.inputChanges();
     }

  show = false;
  show2 = false;

  classifications: any = [];
  maxEmployeeCount = 1000000;

  isInterestMode = false;

  countries: any = [];
  sectors: any = [];
  companies: any = [];

  selectedCompany: any = null;
  isCompanyUserExists = false;

  openRequestDialog = false;
  otpForm!: FormGroup;
  errorMessage = '';
  isDisabledVerify = true;
  isDisabledResendOtp = false;
  txnId = '';


  isOtpSent = false;
  otp = '';
  countdown = 0;
  private countdownSubscription!: Subscription;
  onOtpChange(otp: any): void {
    this.otp = otp;
  }

  ngOnInit(): void {
    this.commonService.formGetMethod('country/list', { fetched: 'all' }).subscribe((res: any) => {
      this.countries = res?.data ?? [];
    }, (error: any) => {
      this.openSnackBar([error?.error?.message || 'Failed to load countries'], '');
    });

    this.commonService.formGetMethod('msme-classification/list', { order: 'DESC', key: 'max_employee_count' }).subscribe((res: any) => {
      if (res && res.data && res.data.length) {
        this.classifications = res.data;
        this.maxEmployeeCount = res.data[0].max_employee_count;
      }
    });
  }
  createSignUpForm(): void {
    this.singupForm = this.formBuilder.group({
      // Common
      email: ['', [Validators.required, Validators.email]],
      country: ['', Validators.required],

      // Enterprise (listed-company path defaults to required)
      sector: ['', Validators.required],
      company: ['', Validators.required],
      name: [''],
      employeeCount: ['', Validators.required],
      msmeType: [''],

      // Interest mode
      companyName: [''],

      // Auth
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    }, { validators: passwordMatchValidator });
  }

  initEmailForm(): void {
    this.emailForm = this.formBuilder.group({
      emailCheck: ['', [Validators.required, Validators.email]]
    });
  }

  checkEmail(): void {
    if (this.emailForm.invalid) { return; }
    this.emailCheckLoading = true;
    this.emailCheckError = '';
    const email = (this.emailForm.get('emailCheck')?.value || '').trim();
    this.commonService.verifyRegistrationEmail(email).subscribe({
      next: (res: any) => {
        this.emailCheckLoading = false;
        const record = res?.data ?? (res?.id ? res : null);
        if (!record) {
          this.emailCheckError = res?.message || 'Email not found or not yet approved.';
          return;
        }
        const status = (record.status ?? '').toLowerCase();
        if (status === 'approved') {
          this.verifiedData = record;
          this.singupForm.get('email')?.setValue(email);
          this.singupForm.get('email')?.disable();
          this.prefillFromVerifiedData(record);
          this.step = 'form';
        } else {
          this.emailCheckError = res?.message || 'Your application is not yet approved.';
        }
      },
      error: (error: any) => {
        this.emailCheckLoading = false;
        this.emailCheckError = error?.error?.message || 'Email not found or not yet approved.';
      }
    });
  }

  prefillFromVerifiedData(data: any): void {
    if (data.country_id) {
      this.singupForm.get('country')?.setValue(data.country_id);
      this.singupForm.get('country')?.disable();
      this.commonService.formGetMethod('sector/list', { country_id: data.country_id }).subscribe((res: any) => {
        this.sectors = res?.data ?? [];
        const sectorId = data.sector_id ?? data['sector.id'];
        if (sectorId) {
          this.singupForm.get('sector')?.setValue(sectorId);
          this.singupForm.get('sector')?.disable();
          this.commonService.formGetMethod('msme/list', { sector_id: sectorId }).subscribe((compRes: any) => {
            this.companies = compRes?.data ?? [];
            if (data.msme_id) {
              this.singupForm.get('company')?.setValue(data.msme_id);
              this.singupForm.get('company')?.disable();
              this.selectedCompany = this.companies?.find((c: any) => c.id === data.msme_id) ?? null;
            } else if (data.company_name) {
              const match = this.companies?.find((c: any) =>
                c.name?.toLowerCase().trim() === data.company_name?.toLowerCase().trim()
              );
              if (match) {
                this.singupForm.get('company')?.setValue(match.id);
                this.singupForm.get('company')?.disable();
                this.selectedCompany = match;
              }
            }
          });
        }
      });
    }
  }

  goToInterestMode(): void {
    this.step = 'form';
    this.enableInterestMode();
  }

  backToEmailStep(): void {
    this.step = 'email';
    this.verifiedData = null;
    this.emailCheckError = '';
    this.isInterestMode = false;
    this.singupForm.get('email')?.enable();
    this.singupForm.get('country')?.enable();
    this.singupForm.get('sector')?.enable();
    this.singupForm.get('company')?.enable();
    this.singupForm.reset();
  }

enableInterestMode(): void {

  this.isInterestMode = true;
  this.selectedCompany = null;
  this.sectors = [];
  this.companies = [];

  // Clear listed-company path values so interest mode has its own state
  this.singupForm.get('country')?.setValue('');
  this.singupForm.get('sector')?.setValue('');
  this.singupForm.get('company')?.setValue('');
  this.singupForm.get('companyName')?.setValue('');
  this.singupForm.get('name')?.setValue('');
  this.singupForm.get('email')?.setValue('');
  this.singupForm.get('employeeCount')?.setValue('');
  this.singupForm.get('msmeType')?.setValue('');
  this.singupForm.get('password')?.setValue('');
  this.singupForm.get('confirmPassword')?.setValue('');

  // Clear validators from non-required fields
  this.singupForm.get('name')?.clearValidators();
  this.singupForm.get('company')?.clearValidators();
  this.singupForm.get('employeeCount')?.clearValidators();
  this.singupForm.get('msmeType')?.clearValidators();
  this.singupForm.get('password')?.clearValidators();
  this.singupForm.get('confirmPassword')?.clearValidators();

  // Clear errors and mark as untouched for non-required fields
  this.singupForm.get('country')?.setErrors(null);
  this.singupForm.get('country')?.markAsUntouched();
  this.singupForm.get('sector')?.setErrors(null);
  this.singupForm.get('sector')?.markAsUntouched();
  this.singupForm.get('email')?.setErrors(null);
  this.singupForm.get('email')?.markAsUntouched();
  this.singupForm.get('name')?.setErrors(null);
  this.singupForm.get('name')?.markAsUntouched();
  this.singupForm.get('company')?.setErrors(null);
  this.singupForm.get('company')?.markAsUntouched();
  this.singupForm.get('employeeCount')?.setErrors(null);
  this.singupForm.get('employeeCount')?.markAsUntouched();
  this.singupForm.get('msmeType')?.setErrors(null);
  this.singupForm.get('msmeType')?.markAsUntouched();
  this.singupForm.get('password')?.setErrors(null);
  this.singupForm.get('password')?.markAsUntouched();
  this.singupForm.get('confirmPassword')?.setErrors(null);
  this.singupForm.get('confirmPassword')?.markAsUntouched();

  // Set validators for required fields in InterestMode (country remains required)
  this.singupForm.get('email')?.setValidators([Validators.required, Validators.email]);
  this.singupForm.get('country')?.setValidators(Validators.required);
  this.singupForm.get('sector')?.setValidators(Validators.required);
  this.singupForm.get('companyName')?.setValidators(Validators.required);

  // Update validity for all controls and form
  this.singupForm.get('name')?.updateValueAndValidity({ emitEvent: false });
  this.singupForm.get('company')?.updateValueAndValidity({ emitEvent: false });
  this.singupForm.get('employeeCount')?.updateValueAndValidity({ emitEvent: false });
  this.singupForm.get('msmeType')?.updateValueAndValidity({ emitEvent: false });
  this.singupForm.get('password')?.updateValueAndValidity({ emitEvent: false });
  this.singupForm.get('confirmPassword')?.updateValueAndValidity({ emitEvent: false });
  this.singupForm.get('email')?.updateValueAndValidity({ emitEvent: false });
  this.singupForm.get('country')?.updateValueAndValidity({ emitEvent: false });
  this.singupForm.get('sector')?.updateValueAndValidity({ emitEvent: false });
  this.singupForm.get('companyName')?.updateValueAndValidity({ emitEvent: false });

  // Clear any form-level errors (like passwordMismatch)
  if (this.singupForm.errors?.passwordMismatch) {
    const errors = { ...this.singupForm.errors };
    delete errors.passwordMismatch;
    this.singupForm.setErrors(Object.keys(errors).length > 0 ? errors : null);
  }

  // Update form-level validity
  this.singupForm.updateValueAndValidity();
}


disableInterestMode(): void {

  this.isInterestMode = false;
  this.isCompanyUserExists = false;
  this.selectedCompany = null;
  this.sectors = [];
  this.companies = [];

  // Clear interest-mode values so listed-company path has its own state
  this.singupForm.get('companyName')?.setValue('');
  this.singupForm.get('country')?.setValue('');
  this.singupForm.get('sector')?.setValue('');
  this.singupForm.get('company')?.setValue('');
  this.singupForm.get('name')?.setValue('');
  this.singupForm.get('email')?.setValue('');
  this.singupForm.get('employeeCount')?.setValue('');
  this.singupForm.get('msmeType')?.setValue('');
  this.singupForm.get('password')?.setValue('');
  this.singupForm.get('confirmPassword')?.setValue('');

  this.singupForm.get('sector')?.setErrors(null);
  this.singupForm.get('company')?.setErrors(null);
  this.singupForm.get('companyName')?.setErrors(null);

  this.singupForm.get('sector')?.clearValidators();
  this.singupForm.get('name')?.clearValidators();
  this.singupForm.get('company')?.clearValidators();
  this.singupForm.get('companyName')?.clearValidators();

  this.singupForm.get('country')?.setErrors(null);
  this.singupForm.get('country')?.markAsUntouched();
  this.singupForm.get('sector')?.setErrors(null);
  this.singupForm.get('sector')?.markAsUntouched();
  this.singupForm.get('email')?.setErrors(null);
  this.singupForm.get('email')?.markAsUntouched();

  this.singupForm.get('email')?.setValidators([Validators.required, Validators.email]);
  this.singupForm.get('country')?.setValidators(Validators.required);
  this.singupForm.get('name')?.setValidators(Validators.required);
  this.singupForm.get('company')?.setValidators(Validators.required);
  this.singupForm.get('sector')?.setValidators(Validators.required);

  this.singupForm.get('employeeCount')?.setValidators(Validators.required);
  this.singupForm.get('msmeType')?.setValidators(Validators.required);

  this.singupForm.get('password')?.setValidators(Validators.required);

  this.singupForm.get('confirmPassword')?.setValidators(Validators.required);

  this.singupForm.updateValueAndValidity();

  if (!this.verifiedData) {
    this.step = 'email';
  }
}

onCountryChange(countryId: string): void {
  this.singupForm.get('sector')?.setValue('');
  this.sectors = [];
  this.companies = [];
  this.singupForm.get('company')?.setValue('');
  if (!countryId) { return; }
  this.commonService.formGetMethod('sector/list', { country_id: countryId }).subscribe((res: any) => {
    this.sectors = res?.data ?? [];
  }, (error: any) => {
    this.openSnackBar([error?.error?.message || 'Failed to load sectors'], '');
  });
}

onSectorChange(sectorId: string): void {

  if (!this.isInterestMode) {
    this.commonService.formGetMethod('msme/list', {sector_id: sectorId}).subscribe((res: any) => {
      this.companies = res?.data;
    },
    (error: any) => {
      this.openSnackBar([error?.error?.message || 'Failed !'], '');
    });
  }
}

onCompanySelect(companyId: string): void {
  this.commonService.formGetMethod('user/view' , { msme_id: companyId }).subscribe((res: any) => {
      const usersForCompany = res?.data?.filter((item: any) => item.msme_id === companyId && item.is_msme_user_active === true) || [];

      if (usersForCompany.length) {
        this.isCompanyUserExists = true;
        this.singupForm.get('company')?.setErrors({ userExists: true });
        this.openSnackBar(['A user already exists for this company.'], '');
      } else {
        this.isCompanyUserExists = false;
        this.singupForm.get('company')?.setErrors(null);
      }

      this.selectedCompany = this.companies?.find((c: any) => c.id === companyId) ?? null;
  },
  (error: any) => {
    this.openSnackBar([error?.error?.message || 'Failed !'], '');
  });
}

onEmployeeCountBlur(): void {
  if (this.singupForm?.controls.employeeCount?.value > this.maxEmployeeCount) {
    this.singupForm.get('employeeCount')?.setErrors({ maxEmployeeCountError: true });
    return;
  }

  this.singupForm.get('msmeType')?.setValue(this.findClassification(this.singupForm?.controls.employeeCount?.value));
}

findClassification(employeeCount: number): number | null {
  if (employeeCount == null) { return null; }

  const classification = this.classifications.find(
    (item: any) =>
      item.min_employee_count <= employeeCount &&
      item.max_employee_count >= employeeCount
  );

  return classification ? classification.id : null;
}


sinUpUser(): void {
  if (this.singupForm?.invalid){
    this.singupForm.markAllAsTouched();
    this.openSnackBar(['all field is required !!'], '', 'warning');
    return;
  }

  const payload: any = {
    isInterestMode: this.isInterestMode,
    country_id: this.singupForm?.controls.country?.value,
    sector_id : this.singupForm?.controls.sector?.value,
    msme_id : this.singupForm?.controls.company?.value,
    employeeCount : this.singupForm?.controls.employeeCount?.value,
    companyName : this.singupForm?.controls.companyName?.value,
    name : this.singupForm?.controls.name?.value,
    email : this.singupForm?.controls.email?.value,
  };

  // Only include password for normal registration (not interest mode)
  if (!this.isInterestMode) {
    const password = this.singupForm?.controls.password?.value;
    const cipherText = this.commonService.getSecratKey(environment.secratKey, password);
    payload.password = cipherText;
  }

  const ipsaPayload: any = {
    email: payload.email,
    password: this.singupForm?.controls.password?.value || ''
  };
  this.registerIdhUser(payload, ipsaPayload);
}

  showPassword(type: any): void {
    if (type === 'pass'){
      this.show = !this.show;
    }else{
      this.show2 = !this.show2;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
  openSnackBar(message: any, action = '', className= 'parmary'): void {
    this.snackBar.open(message, action, {
    duration: 3000,
    panelClass: [className]
  });
}

  backtoHome(): void {
    this.dialogRef.close();
  }
  async openDialog(event: Event): Promise<void> {
    event.preventDefault();
    this.dialogRef.close();
    const login = await import('../login/login.component');
    this.dialog.open(login.LoginComponent, {
      width: '530px',
      panelClass: 'login-dialog-class',
      disableClose: true,
    });
  }

  openRequest(): void {
    this.openRequestDialog = true;
  }

  initializeOtpForm(): void {
    this.otpForm = this.formBuilder.group({
      otp1: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp2: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp3: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp4: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp5: ['', [Validators.required, Validators.pattern(/^\d$/)]],
      otp6: ['', [Validators.required, Validators.pattern(/^\d$/)]],
    });
  }
  focusNext(event: Event, currentInput: HTMLInputElement | any, nextInput: HTMLInputElement): void {
    const maxLength = parseInt(currentInput.maxLength, 10);
    const currentLength = currentInput.value.length;

    if (currentLength >= maxLength) {
      nextInput.focus();
    }
  }

  handleBackspace(event: KeyboardEvent, currentInput: HTMLInputElement, previousInput: HTMLInputElement, otp1: any): void {
    if (event.key === 'Backspace' && currentInput.value.length === 0 && !otp1) {
      previousInput.focus();
    }
  }

  combineAllNumber(): string {
    // Access the values using the form controls
    const otp1 = this.otpForm.controls.otp1.value;
    const otp2 = this.otpForm.controls.otp2.value;
    const otp3 = this.otpForm.controls.otp3.value;
    const otp4 = this.otpForm.controls.otp4.value;
    const otp5 = this.otpForm.controls.otp5.value;
    const otp6 = this.otpForm.controls.otp6.value;

    // Combine the values into a single string
    const combinedValue = otp1 + otp2 + otp3 + otp4 + otp5 + otp6;

    // Log or use the combined value as needed
    return combinedValue;
  }
  verifyOtp(): void {
   const otp = this.combineAllNumber();
   this.isDisabledVerify = true;
   const endPoints = 'otp/verify';
   const params = {
      code: otp,
      txn_id: this.txnId,
    };
   this.commonService.formPostMethod(params, endPoints).subscribe(
      (res: any) => {
      this.isDisabledVerify = true;
      this.openSnackBar([res?.message || 'Success !'], '', 'success');
      this.router.navigate(['/home']);
      this.dialogRef.close();
      },
      (error: any) => {
        this.isDisabledVerify = false;
        this.errorMessage = error?.error?.message;
        this.openSnackBar([error?.error?.message || 'Failed !'], '');
      }
    );
  }

  resendOtp(): void {
    this.errorMessage = '';
    this.isDisabledResendOtp = true;
    this.otpForm.reset();
    const params = {
      txn_id: this.txnId
     };
    this.commonService.formPostMethod(params, '/otp/refresh').subscribe((res: any) => {
      this.openSnackBar([res?.message || 'Success !'] , '', 'success');
      this.isOtpSent = true;
      this.startCountdown(60);
    },
    (error: any) => {
      this.openSnackBar([error?.error?.message || 'Failed !'] , '');
    }
    );
  }
  inputChanges(): void {
    this.otpForm.valueChanges.subscribe(() => {
      if (this.otpForm.status === 'VALID'){
        this.isDisabledVerify = false;
      }else {
        this.isDisabledVerify = true;

      }
    });
  }
  startCountdown(time: number = 60): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
    const timer$ = interval(1000).pipe(take(time)); // Countdown for 60 seconds
    this.countdownSubscription = timer$.subscribe((second) => {
      this.isDisabledResendOtp = false;
      this.countdown = time - second;
      if (time - second === 1) {
      setTimeout(() => {
        this.countdown = 0;
      }, 1000);
      }

    });
  }

  ngOnDestroy(): void {
    if (this.countdownSubscription) {
      this.countdownSubscription.unsubscribe();
    }
  }
  private validatePassword(control: any): { [key: string]: any } | null {
    const password = control.value;
    if (!/[A-Z]/.test(password)) {
      return { uppercase: true };
    }
    if (!/[a-z]/.test(password)) {
      return { lowercase: true };
    }
    if (!/\d/.test(password)) {
      return { number: true };
    }
    if (!/[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(password)) {
      return { specialCharacter: true };
    }
    if (/\s/g.test(password)){
      return  { space: true };
    }
    return null;
  }

  registerUser(payload: any, userResponse: any): void {
    const ipsaPayload = {
      endpoint: `/user/register`,
      headers: {
          'Content-Type': 'application/json',
      },
      requestBody: {
        data: {
          email: payload.email,
          password: payload.password
        }
      },
      method: 'POST'
  };
    this.commonService.registerIpsaUser(ipsaPayload).subscribe((ipsres: any) => {
      if (ipsres.hasOwnProperty('_id')){
        this.openSnackBar([userResponse?.message || 'Success !'] , '', 'success');
        this.isSignUpSuccess = true;
      }
    }, error => {
        this.openSnackBar([error?.error?.message ? error?.error?.message : 'failed !']);
    });
  }


  getTargetterUserData(data: any, userResponse: any): void {
    const endpoint = `/user/submission?data.email=${data.email}`;
    const payload = {
      endpoint,
      headers: {
        'Content-Type': 'application/json'
      },
      requestBody: {},
      method: 'GET'
    };
    this.commonService.targettedUserData(payload).subscribe((res: any) => {
      if (!res.length) {
        this.registerUser(data, userResponse);
      } else {
        this.openSnackBar([userResponse?.message || 'Success !'], '', 'success');
        this.isSignUpSuccess = true;
      }
    });
  }

  registerIdhUser(payload: any, ipsaPayload: any): void {
    // If interest mode, call interest request API instead of OTP flow
    if (this.isInterestMode) {
      this.submitInterestRequest(payload);
      return;
    }

    // Normal registration flow with OTP
    this.commonService.createSignUpUser(payload).subscribe((res: any) => {
      if (res.success){
        this.txnId = res?.data?.txn_id ?? '';
        this.getTargetterUserData(ipsaPayload, res);
      }
    }, (error: any) => {
      this.isSignUpSuccess = false;
      this.openSnackBar([error?.error?.message || 'Failed !'] , '');
    });
  }

  submitInterestRequest(payload: any): void {
    // Call interest request API - using user/inquiry endpoint for interest requests
    const interestPayload = {
      country_id: payload.country_id,
      sector_id: payload.sector_id,
      companyName: payload.companyName,
      email: payload.email,
    };

    this.commonService.formPostMethod(interestPayload, 'interests/create').subscribe((res: any) => {
      this.openSnackBar(['Interest request submitted successfully! Admin will review your request.'], '', 'success');
      // Close dialog after showing success message (no OTP flow)
      setTimeout(() => {
        this.dialogRef.close();
        this.router.navigate(['/home']);
      }, 2000);
    }, (error: any) => {
      this.openSnackBar([error?.error?.message || 'Failed to submit interest request!'] , '');
    });
  }

  privacyStatement(): void {
    const dialogRef = this.dialog.open(GDPRComponent, {
      width: '700px',
      panelClass: 'gdpr-portalDialog',
      data: {}
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
    });
  }
}
